import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 专案组列表
export const setDpgPage: Mutation<IModuleState> = (state, payload) => {
  state.dpgPage.data = payload.data;
  state.dpgPage.pageNum = payload.pageNum;
  state.dpgPage.pageSize = payload.pageSize;
  state.dpgPage.total = payload.total;
  state.dpgPage.loading = !!payload.loading;
};

// 无效的专案组列表
export const setInvalidDpgPages: Mutation<IModuleState> = (state, payload) => {
  state.invalidDpgPage.data = payload.data;
  state.invalidDpgPage.pageNum = payload.pageNum;
  state.invalidDpgPage.pageSize = payload.pageSize;
  state.invalidDpgPage.total = payload.total;
  state.invalidDpgPage.loading = !!payload.loading;
};

// 已删除的专案组列表
export const setRestoreDpgPages: Mutation<IModuleState> = (state, payload) => {
  state.restoreDpgPage.data = payload.data;
  state.restoreDpgPage.pageNum = payload.pageNum;
  state.restoreDpgPage.pageSize = payload.pageSize;
  state.restoreDpgPage.total = payload.total;
  state.restoreDpgPage.loading = !!payload.loading;
};

// 专案组详情
export const setDpgDetail: Mutation<IModuleState> = (state, payload) => {
  state.dpgDetail.data = payload.data;
  state.dpgDetail.loading = !!payload.loading;
};

// 专案组操作日志
export const setDpgLogs: Mutation<IModuleState> = (state, payload) => {
  state.dpgLogs.data = payload.data;
  state.dpgLogs.pageNum = payload.pageNum;
  state.dpgLogs.pageSize = payload.pageSize;
  state.dpgLogs.total = payload.total;
  state.dpgLogs.loading = !!payload.loading;
};

// 待添加的物品列表(左库)
export const setAllModels: Mutation<IModuleState> = (state, payload) => {
  state.allModels.data = payload.data;
  state.allModels.total = payload.total;
  state.allModels.pageNum = payload.pageNum;
  state.allModels.pageSize = payload.pageSize;
  state.allModels.loading = !!payload.loading;
};

// 待添加的材料列表(左库)
export const setAllMaterials: Mutation<IModuleState> = (state, payload) => {
  state.allMaterials.data = payload.data;
  state.allMaterials.total = payload.total;
  state.allMaterials.pageNum = payload.pageNum;
  state.allMaterials.pageSize = payload.pageSize;
  state.allMaterials.loading = !!payload.loading;
};

// 专案的物品列表(右库)
export const setLibModels: Mutation<IModuleState> = (state, payload) => {
  state.libModels.data = payload.data;
  state.libModels.loading = !!payload.loading;
};

// 专案的材料列表(右库)
export const setLibMaterials: Mutation<IModuleState> = (state, payload) => {
  state.libMaterails.data = payload.data;
  state.libMaterails.loading = !!payload.loading;
};

// 专案的拼装家具列表(右库)
export const setLibFurnitures: Mutation<IModuleState> = (state, payload) => {
  state.libFurnitures.data = payload.data;
  state.libFurnitures.loading = !!payload.loading;
};

// 物料库调整日志(右库)
export const setLibLogs: Mutation<IModuleState> = (state, payload) => {
  state.libLogs.data = payload.data;
  state.libLogs.pageNum = payload.pageNum;
  state.libLogs.pageSize = payload.pageSize;
  state.libLogs.total = payload.total;
  state.libLogs.loading = !!payload.loading;
};

// 子专案列表
export const setDpjList: Mutation<IModuleState> = (state, payload) => {
  state.dpjList.data = payload.data;
  state.dpjList.loading = !!payload.loading;
};

// 拥有专案的组织列表
export const setDpgOrgs: Mutation<IModuleState> = (state, payload) => {
  state.dpgOrgs.data = payload.data;
  state.dpgOrgs.loading = !!payload.loading;
};

// 渠道组织列表(用于交付)
export const setChannelOrgs: Mutation<IModuleState> = (state, payload) => {
  state.channelOrgs.data = payload.data;
  state.channelOrgs.loading = !!payload.loading;
};

// 当前组织归属的品牌列表(用于发布)
export const setOwnBrands: Mutation<IModuleState> = (state, payload) => {
  state.ownerBrands.data = payload.data;
  state.ownerBrands.loading = !!payload.loading;
};

// 已保存的过滤项配置
export const setSavedFilters: Mutation<IModuleState> = (state, payload) => {
  state.savedFilters.data = payload.data;
  state.savedFilters.loading = !!payload.loading;
};

// 专案状态字典
export const setStatusTypes: Mutation<IModuleState> = (state, payload) => {
  state.statusTypes.data = payload.data;
  state.statusTypes.loading = !!payload.loading;
};

// 普通弹窗
export const setDialog: Mutation<IModuleState> = (state, payload) => {
  state.dialog.type = payload.type || '';
  state.dialog.data = payload.data || null;
  state.dialog.visible = !!payload.visible;
  state.dialog.loading = !!payload.loading;
};

// 确认弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.type = payload.type;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.data = payload.data || null;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

// 列表搜索条件
export const setSearch: Mutation<IModuleState> = (state, payload) => {
  state.search = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = !!payload;
};
